// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.selectorsWrapper__d2c {
  display: flex;
  align-items: center;
  gap: var(--ring-unit);
  max-width: calc(var(--ring-unit) * 40);

  .channelOrVersion__d03 {
    width: calc(var(--ring-unit) * 18);
    flex: 0 0 auto;
  }

  .versionSelector__d2a,
  .channelSelector__e77 {
    flex: 1 0 100%;
  }
}

.actionSelector__d8b {
  margin-top: var(--ring-unit);
}
`, "",{"version":3,"sources":["webpack://./src/modules/ide-provisioner/plugins-rules/plugins-rule/single-plugin-rule/internal-repo-plugin-content/internal-repo-plugin-content.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,qBAAqB;EACrB,sCAAsC;;EAEtC;IACE,kCAAkC;IAClC,cAAc;EAChB;;EAEA;;IAEE,cAAc;EAChB;AACF;;AAEA;EACE,4BAA4B;AAC9B","sourcesContent":[".selectorsWrapper {\n  display: flex;\n  align-items: center;\n  gap: var(--ring-unit);\n  max-width: calc(var(--ring-unit) * 40);\n\n  .channelOrVersion {\n    width: calc(var(--ring-unit) * 18);\n    flex: 0 0 auto;\n  }\n\n  .versionSelector,\n  .channelSelector {\n    flex: 1 0 100%;\n  }\n}\n\n.actionSelector {\n  margin-top: var(--ring-unit);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"selectorsWrapper": `selectorsWrapper__d2c`,
	"channelOrVersion": `channelOrVersion__d03`,
	"versionSelector": `versionSelector__d2a`,
	"channelSelector": `channelSelector__e77`,
	"actionSelector": `actionSelector__d8b`
};
export default ___CSS_LOADER_EXPORT___;
